import { render, staticRenderFns } from "./ModalProcessTabHistory.vue?vue&type=template&id=2323a48b&scoped=true"
import script from "./ModalProcessTabHistory.vue?vue&type=script&lang=js"
export * from "./ModalProcessTabHistory.vue?vue&type=script&lang=js"
import style0 from "./ModalProcessTabHistory.vue?vue&type=style&index=0&id=2323a48b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2323a48b",
  null
  
)

export default component.exports